import { Controller } from "@hotwired/stimulus"

// Shift configuration controller for assigning shift definitions to plants.
// Validates that at least one shift definition is selected before submission.
export default class extends Controller {
  static targets = ["checkbox"]

  validate(event) {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    if (checked.length === 0) {
      event.preventDefault()
      alert("At least one shift definition must be selected.")
    }
  }
}
